import { withNestedView } from '@/router/routerHelpers';
const loadView = withNestedView('contacts');

const contactsRoutes = [
  {
    path: '/contacts',
    component: {
      render: (c) => c('router-view'),
    },
    children: [
      {
        path: '',
        meta: { showNav: true, feature: 'contacts' },
        component: loadView('Contacts'),
        children: [
          {
            path: '',
            name: 'contacts-main',
            meta: { feature: 'contacts' },
            component: loadView('ContactsMain'),
          },
          {
            path: 'archived',
            name: 'contacts-archived',
            component: loadView('ContactsMain'),
            props: {
              archived: true,
            },
            meta: {
              feature: 'contacts_archived',
            },
          },
          {
            path: 'notes',
            name: 'contacts-notes',
            component: loadView('notes/ContactsNotes'),
            meta: {
              feature: 'contacts_notes',
            },
          },
          {
            path: 'tasks',
            name: 'contacts-tasks',
            meta: {
              feature: 'contacts_tasks',
            },
            component: loadView('tasks/ContactsTasks'),
          },
        ],
      },

      {
        path: 'create',
        name: 'contact-create',
        props: true,
        meta: { feature: 'contacts' },
        component: loadView('contact/ContactCreate'),
      },
      {
        path: 'import',
        name: 'contacts-import',
        props: true,
        meta: { feature: 'contacts' },
        component: loadView('import/ContactsImportView'),
      },
      {
        path: 'import/status/:importId',
        name: 'contacts-import-status',
        props: true,
        meta: { feature: 'contacts' },
        component: loadView('import/ContactsImportStatusView'),
      },
      {
        path: 'boards',
        name: 'contacts-boards',
        props: true,
        meta: {
          feature: 'contacts_boards',
        },
        component: loadView('boards/ContactsBoards'),
      },
      {
        path: 'relationships',
        name: 'contacts-relationships',
        props: true,
        meta: {
          permission: 'contacts_relationships',
          feature: 'contacts',
        },
        component: loadView('relationships/ContactsRelationships'),
      },
      {
        path: ':id',
        name: 'contact-edit',
        props: true,
        meta: { feature: 'contacts' },
        component: loadView('contact/ContactPage'),
      },
    ],
  },
];

export default contactsRoutes;
